import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_2 = {
  key: 1,
  class: "mt-3 space-y-1"
}
const _hoisted_3 = { class: "font-medium" }

import { computed } from 'vue'

import { runHeadline } from '@/helpers/parsley'
import { useParsleyRunTracker } from '@/helpers/parsleyRunTracker'

const LOST_NOTE = 'We lost touch with this run. Refresh the page to see how it ended.'
const PRODUCTS_PATH = '/store/products'


export default {
  __name: 'ParsleyRunBanner',
  setup(__props) {

const { run, running, finished, lost } = useParsleyRunTracker()

const headline = computed(() => runHeadline(run.value))
// New products land in the library only, which the Parsley products tab hides
// by default, so the merchant is pointed there.
const madeProducts = computed(
  () => finished.value && run.value.attributes.kind === 'create_products' && run.value.attributes.summary?.created > 0
)
const problems = computed(() => (running.value || lost.value ? [] : run.value?.attributes.problems ?? []))
const toneClass = computed(() =>
  run.value?.attributes.status === 'failed' && !lost.value ? 'border-red-200 bg-red-50' : 'border-gray-200 bg-white'
)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_unref(run))
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(["mb-6 rounded-xl border px-5 py-4", toneClass.value]),
        role: "status"
      }, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(lost) ? LOST_NOTE : headline.value), 1),
        (madeProducts.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: PRODUCTS_PATH,
              class: "mt-1 inline-block text-sm font-medium text-brand-600 hover:text-brand-700"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" See them in your product library ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (problems.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(problems.value, (problem, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "text-sm text-gray-700"
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(problem.product_name || problem.parsley_name) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(problem.message), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

}